const content = {
  title: "Present Simple – Basics",
  explanation: `
We use the Present Simple for routines that repeat regularly.
Example: I wake up at 7:00 every day.

We use it for habits and personal behavior patterns.
Example: She always drinks tea in the morning.

We also use it for facts and general truths that do not change.
Example: Water boils at 100 degrees Celsius.

At A1 level, focus on building short, clear sentences with correct subject-verb form.
Example: He plays football on Fridays.
  `,
  rules: [
    "I / You / We / They + base verb (work, live, play)",
    "He / She / It + verb + s (works, lives, plays)",
    "Use 'do' or 'does' to form questions",
    "Use 'do not (don't)' or 'does not (doesn't)' for negatives",
    "Time expressions: every day, usually, often, always"
  ],
  examples: [
    "I work every day.",
    "She lives in Cairo.",
    "They play football on weekends.",
    "He doesn't like coffee.",
    "Do you study English?"
  ]
};

export default content;


